import FinalizeMatch from "./finalize-match";

export default class FinalizeDoubleMatch extends FinalizeMatch {
    // eslint-disable-next-line no-unused-vars
    applicable(gameContext, ruleContext, eventConfiguration, { match }) {
        return !match.isSingle;
    }
}
